<template>
  <footer class="footer">
    <div class="inner">
      <div class="footer__logo">
        <img src="../assets/images/common/logo.png" alt />
      </div>
      <p class="footer__read">
        エヌケー・テック株式会社は、ホームページの企画・制作をはじめ、各種Webアプリケーション、インターネットサーバ、社内LANなど、
        <br />お客さまのネット戦略を強力にバックアップする、インターネットのトータル・プロデュース・カンパニーです。
        <br />常に最新のトレンドに対応した「ビジネスにプラスとなるWeb」を提案・作成します。
      </p>
      <a href="https://secure.multi.ne.jp/nk/nk-tech/contact/" class="footer__btn">CONTACT</a>
    </div>
    <p class="footer__copy">
      <small>Copyright © NK Tech Co., Ltd. All Rights Reserved.</small>
    </p>
  </footer>
</template>


<script>
export default {
  name: "Footer"
};
</script>


<style>
</style>
